import { useSystemHealthDotQuery } from '../../../hooks/admin/useSystemHealth'
import { deriveHealthLevel, healthLevelClasses, healthLevelLabel } from '../../../utils/systemHealthStatus'
import { cn } from '../../../shared/utils/cn'

interface HealthDotProps {
  className?: string
}

export function HealthDot({ className }: HealthDotProps) {
  const { data, isLoading } = useSystemHealthDotQuery()
  const level = deriveHealthLevel(data)
  const classes = healthLevelClasses(level)

  return (
    <span
      className={cn(
        'inline-block h-2.5 w-2.5 rounded-full',
        isLoading ? 'bg-gray-300 animate-pulse' : classes.dot,
        className
      )}
      title={isLoading ? 'Checking system health…' : `System: ${healthLevelLabel(level)}`}
      aria-label={isLoading ? 'Checking system health' : `System ${healthLevelLabel(level)}`}
    />
  )
}
